import { useEffect, useRef } from 'react';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { logout } from '@/store/auth/authSlice';

const API_URL = import.meta.env.VITE_API_URL;
const POLL_INTERVAL_MS = Number(import.meta.env.VITE_HEALTH_POLL_INTERVAL_MS); // 60s

export function useBackendHealth() {
  const dispatch = useDispatch();
  const reportedRef = useRef(false);

  useEffect(() => {
    // Pois päältä devausmodessa
    if (import.meta.env.MODE === 'development') return;
    let intervalId;

    const checkHealth = async () => {
      try {
        await axios.get(`${API_URL}/health`, { timeout: 3000 });
        reportedRef.current = false;
      }
      catch (e) {
        if (!reportedRef.current && import.meta.env.MODE !== 'development') {
          Sentry.captureMessage('Backend unreachable', {
            level: 'error',
            tags: { type: 'backend_health' },
          });
          reportedRef.current = true;
        }

        toast.error('Taustapalvelimeen ei saada yhteyttä, ylläpitoa on huomautettu automaattisesti. Sinut on kirjattu ulos.');
        dispatch(logout());
      }
    };

    checkHealth();
    intervalId = setInterval(checkHealth, POLL_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [dispatch]);
}
